// Google Analytics 4 helpers. The tag itself is loaded in public/index.html (and only on the live site, never on localhost), where gtag is set up
// with automatic page views switched OFF: every page view is sent from here, after the page title is set, so reports show the right page name.
// In Google Analytics the stream setting "Page changes based on browser history events" must be OFF, or each page would be counted twice.
// Events carry only an event name and a few non-personal labels (never a name, phone number, email or profile detail).
const send = (...args) => {
    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag(...args);
    } catch (error) { /* analytics must never break the page */ }
};

export const trackEvent = (name, params = {}) => send('event', name, params);

// the same page is never reported twice within a second (React's development mode runs effects twice, and a page can ask again once its title loads)
let lastView = { key: '', at: 0 };

export const trackPageView = () => {
    const key = `${window.location.pathname}${window.location.search}|${document.title}`;
    const now = Date.now();
    if (key === lastView.key && now - lastView.at < 1000) return;
    lastView = { key, at: now };
    send('event', 'page_view', {
        page_title: document.title,
        page_location: `${window.location.origin}${window.location.pathname}${window.location.search}`,
        page_path: window.location.pathname,
    });
};
